export const EndPoints = {
    LOG_IN: 'api/Authentication/login',
    REQUEST_PASSWORD_RESET: 'api/UserManagement/RequestPasswordReset',
    RESET_PASSWORD: 'api/UserManagement/ResetPassword',
    GET_SEX_OPTIONS: 'api/UsepPredictor/GetSexOptions',
    GET_STONE_POSITION_OPTIONS: 'api/UsepPredictor/GetStonePositionOptions',
    GET_FEVER_OPTIONS: 'api/UsepPredictor/GetFeverOptions',
    GET_PREVIOUS_STONE_EXPLUSION_OPTIONS: 'api/UsepPredictor/GetPreviousStoneExpulsionOptions',
    GET_PREVIOUS_UROLOGIC_TREATMENT_OPTIONS: 'api/UsepPredictor/PreviousUrologicTreatmentOptions',

    SVM_PREDICT: 'api/UsepPredictor/SvmPredict',

    TRAINER_DOWNLOAD_DATABASE: 'api/UsepTrainer/SvmDatabaseDownload',
    TRAINER_UPLOAD_FILE: 'api/UsepTrainer/SvmDatabaseUpload',
    TRAINER_TRAIN_MODEL: 'api/UsepTrainer/SvmTrainDefault',
    TRAINER_GET_CURRENT_MODEL: 'api/UsepTrainer/SvmGetCurrentModelInfo',

    USER_MANAGEMENT_GET_USERS: 'api/UserManagement/GetAllUsers',
    USER_MANAGEMENT_ADD_USER: 'api/UserManagement/AddUser',
    USER_MANAGEMENT_CHANGE_ROLE: 'api/UserManagement/ChangeRole',
    USER_MANAGEMENT_ENABLE_USER: 'api/UserManagement/EnableUser',

    GET_LANGUAGES: 'api/UsepLanguage/GetLanguages'
}

export const AppRoutes = {
    LOG_IN: '/',
    PREDICTIONS: '/predictions',
    PREDICTION_RESULTS: '/prediction-results',
    MODEL_TRAINING: '/model-training',
    USER_MANAGEMENT: '/user-management',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    ABOUT: '/about'
}